import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ErrorCircleIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <circle cx="12" cy="12" r="12" fill="#F94264" />
            <path d="M12 6.59998L12 12.9" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M12 17.1299L12 17.1389" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
        </SvgIcon>
    );
};
